"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichAdsOptions = void 0;
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
const helpers_1 = require("./helpers");
function enrichAdsOptions(adsOptions, videoElement, device, autoplay) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { ifa, ifaType } = (0, js_player_shared_1.getSessionIFA)();
        return Object.assign({ deviceType: device.type, deviceModel: device.model, deviceModelNumber: device.modelNumber, deviceMake: device.manufacturer, width: videoElement.offsetWidth, height: videoElement.offsetHeight, pageUrl: window.location.href, domain: ((_a = (0, helpers_1.getIframeURL)()) === null || _a === void 0 ? void 0 : _a.hostname) || window.location.hostname, mute: videoElement.muted, autoplay,
            ifa,
            ifaType }, adsOptions);
    });
}
exports.enrichAdsOptions = enrichAdsOptions;
//# sourceMappingURL=adsOptionsHelper.js.map